export default __webpack_public_path__ + "static/media/hsc-logo-text.df6bcb36.svg";